import React from 'react';
import { TouchableOpacity, Image, StyleSheet } from 'react-native';
import { View } from 'native-base';
import { MaterialCommunityIcons } from '@expo/vector-icons';

function TripPhotoSlot({ photo, onPress, readonly }) {
  return (
    <TouchableOpacity onPress={onPress} disabled={readonly && !photo} style={styles.slot}>
      {photo ? (
        <>
          <Image source={{ uri: photo }} style={styles.image} resizeMode="cover" />
          {!readonly && (
            <View style={styles.overlay}>
              <MaterialCommunityIcons name="pencil" size={14} color="white" />
            </View>
          )}
        </>
      ) : (
        <View style={styles.empty}>
          <MaterialCommunityIcons name="camera-plus-outline" size={28} color="#9ca3af" />
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  slot: {
    width: 72,
    height: 72,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#f3f4f6',
    borderWidth: 1,
    borderColor: '#e5e7eb',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  overlay: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 10,
    padding: 2,
  },
  empty: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default TripPhotoSlot;
